import { QUERY_KEY } from 'constants/globalConstants'
import DashboardApiService from 'apiService/dashboardApiService'
import { useQuery } from 'react-query'

const useNodeLogDetails = (id, nodeId, pageSize, currentPage) => {
    return useQuery(QUERY_KEY.NODE_LOG_DETAILS, () => DashboardApiService.getNodeLogRange(id, nodeId, pageSize, currentPage), {retry: false})
}

export default useNodeLogDetails